import React, { useEffect, useState } from "react";
import "./ContactList.css";
import { Contact, fetchAll, PaginationMeta } from "../../services/contact";
import { toast } from "react-toastify";

const ContactsList: React.FC = () => {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<PaginationMeta>({
    page: 1,
    limit: 20,
    totalPages: 1,
    totalContacts: 0,
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchContacts = async (page: number) => {
    setIsLoading(true);
    try {
      const response = await fetchAll(page, paginationMeta.limit);
      setContacts(response.data);
      setPaginationMeta(response.meta);
    } catch (error) {
      toast.error("Failed to fetch contacts! Please, try again later!");
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts(paginationMeta.page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationMeta.page, paginationMeta.limit]);

  const handleNextPage = () => {
    if (paginationMeta.page < paginationMeta.totalPages) {
      setPaginationMeta((prev) => ({ ...prev, page: prev.page + 1 }));
    }
  };

  const handlePrevPage = () => {
    if (paginationMeta.page > 1) {
      setPaginationMeta((prev) => ({ ...prev, page: prev.page - 1 }));
    }
  };

  return (
    <div>
      <h2>Contacts List ({paginationMeta.totalContacts})</h2>
      {isLoading ? (
        <p>Loading contacts...</p>
      ) : (
        <>
          <table className="contacts-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact.id}>
                  <td>{contact.firstName}</td>
                  <td>{contact.lastName}</td>
                  <td>{contact.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination">
            <button
              onClick={handlePrevPage}
              disabled={paginationMeta.page === 1}
              className="page-button"
            >
              Previous
            </button>
            <span className="pagination-info">
              Page {paginationMeta.page} of {paginationMeta.totalPages}
            </span>
            <button
              onClick={handleNextPage}
              disabled={paginationMeta.page === paginationMeta.totalPages}
              className="page-button"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactsList;
